import { AppBar, Box, ButtonBase, Grid } from '@material-ui/core'
import SearchBar from 'components/SearchBar'
import { SearchBarProps } from 'components/SearchBar/SearchBar'
import * as React from 'react'
import TestIDs from '../../utils/TestIDs'
import colors from 'utils/colors'

export interface HeaderProps {
    onLogoClick: () => void
    searchBarProps?: SearchBarProps
}

const HeaderPublic = (props: HeaderProps): JSX.Element => {
    const { onLogoClick, searchBarProps } = props
    const enableSearchbar = false

    return (
        <AppBar
            position={'static'}
            {...TestIDs.GET_BASE('HEADER')}
            style={{ backgroundColor: colors.main, paddingTop: 30, paddingBottom: 30 }}
        >
            <Grid container spacing={2} alignItems={'center'} justify={'space-between'}>
                <Grid item sm={searchBarProps ? 12 : true} md={searchBarProps ? 'auto' : true} xs={12}>
                    <Box
                        width={1}
                        display={'flex'}
                        justifyContent={searchBarProps ? 'center' : { xs: 'center', sm: 'flex-start' }}
                        alignItems={'center'}
                    >
                        <ButtonBase onClick={onLogoClick} disableRipple disableTouchRipple>
                            <img
                                src={process.env.PUBLIC_URL + '/logo.png'}
                                alt={'logo.png'}
                                style={{ maxWidth: 180, maxHeight: 60, width: '100%', marginLeft: 30 }}
                            />
                        </ButtonBase>
                    </Box>
                </Grid>
                {searchBarProps && enableSearchbar && (
                    <Grid container item md xs={12} alignItems={'center'} justify={'center'}>
                        <Box width={{ xs: 1, md: 0.5 }} maxWidth={{ xs: undefined, sm: '300px' }}>
                            <SearchBar {...searchBarProps} />
                        </Box>
                    </Grid>
                )}
            </Grid>
        </AppBar>
    )
}

export default HeaderPublic
